const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export function getUnblockWebImageUrl(filename) {
    if (!filename) return '';
    return `${API_BASE}/api/unblock-web/image/${encodeURIComponent(filename)}`;
}
